import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  analytics: [], // Initial analytics array
};

const analyticSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    analytics: (state, action) => {
        state.analytics = action.payload;
    },
  },
});

export const {
  analytics,
} = analyticSlice.actions;

export default analyticSlice.reducer;